import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UrlConstants } from '../../pages/common/constants/url.constants';
import { openInNewTab } from '../../pages/common/utils/navigate-to';
import { FsthpMasterDataStore } from '../services/fsthp-master-data.store';

@Component({
  selector: 'app-nav-menu',
  imports: [NgOptimizedImage],
  templateUrl: './nav-menu.component.html',
  styleUrl: './nav-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavMenuComponent {
  protected readonly masterDataStore = inject(FsthpMasterDataStore);
  protected readonly UrlConstants = UrlConstants;
  /**
   * よくある質問を別タブで表示する（マスタURLが無い場合は何もしない）
   */
  openFaq(): void {
    const faqUrl = this.masterDataStore.getTransitionDestinationUrl(UrlConstants.FAQ_URL);
    if (faqUrl) {
      openInNewTab(faqUrl);
    }
  }

  /**
   * ウィンドウを閉じる（PCヘッダーと同じ）
   */
  closeWindow(): void {
    window.close();
  }
}
